import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@sbv-clients/shared-feature-auth';
import { OverlayLoader } from '@sbv-clients/ui-shared';

type AuthGuardProps = PropsWithChildren;

const PublicRouteGuard = ({ children }: AuthGuardProps) => {
  const { initialised, authenticated } = useAuth();

  if (!initialised) {
    return <OverlayLoader />;
  }

  if (authenticated) {
    return <Navigate to="/" />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default PublicRouteGuard;
